var FileSelectionFilter;
(function (FileSelectionFilter) {
    FileSelectionFilter[FileSelectionFilter["None"] = 0] = "None";
    FileSelectionFilter[FileSelectionFilter["Images"] = 1] = "Images";
})(FileSelectionFilter || (FileSelectionFilter = {}));
export default FileSelectionFilter;
//# sourceMappingURL=FileSelectionFilter.js.map